import { BrandedProductId } from '@seek/hirer-products-shim';

import { STANDOUT_SELECTION_STORAGE_KEY } from 'src/app/shared/constants/storage';
import type { CartItem } from 'src/graphql/generated';

export const getHasStandOutBeenSelected = (cart?: CartItem[]) => {
  // A cart has not been loaded
  if (!cart) return false;

  // Premium upsell has been shown before
  if (sessionStorage.getItem(STANDOUT_SELECTION_STORAGE_KEY) === 'true')
    return true;

  // Determine if a standout ad is currently in cart
  const standoutSelected = Boolean(
    cart.find((item) => item.product.id === BrandedProductId),
  );

  // If standout is in cart, set it in storage
  if (standoutSelected) {
    sessionStorage.setItem(
      STANDOUT_SELECTION_STORAGE_KEY,
      standoutSelected.toString(),
    );
  }
  return standoutSelected;
};
